import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Innovation from './components/Innovation';
import Market from './components/Market';
import ESG from './components/ESG';
import Reference from './components/Reference';
import Contact from './components/Contact';
import SEOJsonLD from '../../components/feature/SEOJsonLD';

export default function Home() {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const handleMenuClick = (sectionId: string) => {
    setActiveSection(sectionId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleLogoClick = () => {
    setActiveSection(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOJsonLD />
      <Navbar activeSection={activeSection} onMenuClick={handleMenuClick} onLogoClick={handleLogoClick} />

      {activeSection === null && <Hero />}

      {activeSection === 'problem' && (
        <div className="pt-20">
          <Problem />
        </div>
      )}
      {activeSection === 'innovation' && (
        <div className="pt-20">
          <Innovation />
        </div>
      )}
      {activeSection === 'market' && (
        <div className="pt-20">
          <Market />
        </div>
      )}
      {activeSection === 'esg' && (
        <div className="pt-20">
          <ESG />
        </div>
      )}
      {activeSection === 'reference' && (
        <div className="pt-20">
          <Reference />
        </div>
      )}
      {activeSection === 'contact' && (
        <div className="pt-20">
          <Contact />
        </div>
      )}
    </div>
  );
}
